/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Backup_Llm_HelpInputs */

const en_ad_backup_llm_help = /** @type {(inputs: Ad_Backup_Llm_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If the primary AI fails, the job will retry with this backup provider before failing the event.`)
};

const fr_ad_backup_llm_help = /** @type {(inputs: Ad_Backup_Llm_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si l'IA principale échoue, la tâche tentera de s'exécuter à nouveau avec ce fournisseur de secours avant de déclarer l'événement comme défaillant.`)
};

const de_ad_backup_llm_help = /** @type {(inputs: Ad_Backup_Llm_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falls die primäre KI ausfällt, wird der Auftrag mit diesem Backup-Anbieter erneut versucht, bevor das Ereignis als fehlgeschlagen gilt.`)
};

const it_ad_backup_llm_help = /** @type {(inputs: Ad_Backup_Llm_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se l'IA principale fallisce, il processo tenterà di nuovo con questo provider di backup prima di dichiarare l'evento fallito.`)
};

const ru_ad_backup_llm_help = /** @type {(inputs: Ad_Backup_Llm_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Если основной ИИ выйдет из строя, задание повторится с использованием этого резервного поставщика, прежде чем событие завершится с ошибкой.`)
};

const es_ad_backup_llm_help = /** @type {(inputs: Ad_Backup_Llm_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si la IA principal falla, la tarea se reintentará con este proveedor de respaldo antes de que falle el evento.`)
};

const zh_cn2_ad_backup_llm_help = /** @type {(inputs: Ad_Backup_Llm_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果主 AI 出现故障，则在事件失败之前，该任务将使用此备用提供程序重试。`)
};

const ja_ad_backup_llm_help = /** @type {(inputs: Ad_Backup_Llm_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プライマリAIが失敗した場合、ジョブはイベントを失敗させる前に、このバックアッププロバイダを使用して再試行します。`)
};

const hi_ad_backup_llm_help = /** @type {(inputs: Ad_Backup_Llm_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यदि प्राथमिक एआई विफल हो जाता है, तो कार्य विफल होने से पहले इस बैकअप प्रदाता के साथ पुनः प्रयास करेगा।`)
};

const pt_pt2_ad_backup_llm_help = /** @type {(inputs: Ad_Backup_Llm_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caso a IA principal falhe, a tarefa será repetida com este provedor de backup antes de o evento ser considerado como falha.`)
};

/**
* | output |
* | --- |
* | "If the primary AI fails, the job will retry with this backup provider before failing the event." |
*
* @param {Ad_Backup_Llm_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_backup_llm_help = /** @type {((inputs?: Ad_Backup_Llm_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Backup_Llm_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_backup_llm_help(inputs)
	if (locale === "de") return de_ad_backup_llm_help(inputs)
	if (locale === "it") return it_ad_backup_llm_help(inputs)
	if (locale === "ru") return ru_ad_backup_llm_help(inputs)
	if (locale === "es") return es_ad_backup_llm_help(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_backup_llm_help(inputs)
	if (locale === "ja") return ja_ad_backup_llm_help(inputs)
	if (locale === "hi") return hi_ad_backup_llm_help(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_backup_llm_help(inputs)
	return en_ad_backup_llm_help(inputs)
});